<!-- Link Item -->
@if (isLink(item())) {
    <a
      [routerLink]="$any(item()).route"
      [routerLinkActiveOptions]="$any(item()).routerLinkActiveOptions || { exact: false }"
      routerLinkActive="active"
      class="flex items-center gap-3 px-3 py-2.5 text-base text-pmdf-base-primary font-extralight hover:text-pmdf-base-primary hover:bg-pmdf-surface/10 rounded-pmdf-card transition-all duration-200"
      [matTooltip]="!expanded() ? item().label : ''"
      [matTooltipPosition]="'right'"
      [matTooltipDisabled]="expanded()"
      [class.justify-center]="!expanded()"
      [class.flex-col]="!expanded()"
    >
      <!-- Icon: fixed width -->
      @if ($any(item()).svgIcon) {
        <mat-icon [svgIcon]="$any(item()).svgIcon" class="icon-lg shrink-0 transition-colors duration-200 text-pmdf-base-secondary font-light" [class.mb-1]="!expanded()"></mat-icon>
      } @else if ($any(item()).icon) {
        <mat-icon class="icon-lg shrink-0 transition-colors duration-200 text-pmdf-base-secondary font-light" [class.mb-1]="!expanded()">
          {{ $any(item()).icon }}
        </mat-icon>
      }
      
      <!-- Label: flexible width -->
      @if (expanded()) {
        <span class="flex-1 font-extralight">{{ item().label }}</span>
      }
      
      <!-- Badge: fixed width (expanded mode) -->
      @if (expanded() && !badgeHidden($any(item()))) {
        <span class="shrink-0 rounded-full px-2 py-0.5 text-xs font-extralight text-pmdf-warning" [class]="getBadgeClasses($any(item()).badge)">
          {{ badgeValue($any(item())) }}
        </span>
      }
      
      <!-- Badge: mini badge (rail mode) -->
      @if (!expanded() && !badgeHidden($any(item()))) {
        <span class="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full text-lg font-extralight">
          {{ badgeValue($any(item())) }}
        </span>
      }
    </a>
  }
  
  <!-- Dropdown Item -->
  @if (isDropdown(item())) {
    <div class="sidenav-dropdown">
      <!-- Dropdown Button -->
      <button
        (click)="toggleExpanded()"
        type="button"
        class="text-pmdf-base-secondary font-light hover:text-pmdf-base-secondary hover:bg-pmdf-surface/10 flex items-center gap-3 px-3 py-2.5 rounded-pmdf-card text-base transition-all duration-200 w-full relative"
        [matTooltip]="!expanded() ? item().label : ''"
        [matTooltipPosition]="'right'"
        [matTooltipDisabled]="expanded()"
        [class.justify-center]="!expanded()"
        [class.flex-col]="!expanded()"
      >
        <!-- Icon: fixed width -->
        @if ($any(item()).svgIcon) {
          <mat-icon [svgIcon]="$any(item()).svgIcon" class="icon-lg shrink-0 transition-colors duration-200 text-pmdf-base-secondary font-light" [class.mb-1]="!expanded()"></mat-icon>
        } @else if ($any(item()).icon) {
          <mat-icon class="icon-lg shrink-0 transition-colors duration-200 text-pmdf-base-secondary font-light" [class.mb-1]="!expanded()">
            {{ $any(item()).icon }}
          </mat-icon>
        }
        
        <!-- Label: flexible width -->
        @if (expanded()) {
          <span class="flex-1 text-left font-extralight text-pmdf-base-primary">{{ item().label }}</span>
        }
        
        <!-- Badge: fixed width (expanded mode, if no children visible) -->
        @if ($any(item()).badge && expanded() && !isExpanded() && $any(item()).badge.value !== '0') {
          <span class="shrink-0 rounded-full px-2 py-0.5 text-xs font-extralight" [class]="getBadgeClasses($any(item()).badge)">
            {{ $any(item()).badge.value }}
          </span>
        }
        
        <!-- Chevron: fixed width (expanded mode) -->
        @if (expanded()) {
          <mat-icon class="sidenav-chevron text-pmdf-base-primary font-light shrink-0 transition-transform duration-200" 
                    [class.rotate-180]="isExpanded()">
            expand_more
          </mat-icon>
        }
        
        <!-- Badge: mini badge (rail mode) -->
        @if ($any(item()).badge && !expanded() && $any(item()).badge.value !== '0') {
          <span class="absolute right-1 top-1 flex h-4 w-4 items-center justify-center rounded-full text-xs font-bold text-pmdf-base-secondary shadow-sm">
            {{ $any(item()).badge.value }}
          </span>
        }
      </button>
      
      <!-- Submenu Container (transição via grid-template-rows: abre na hora, sem cauda e sem travar) -->
      @if (expanded()) {
        <div class="sidenav-submenu-wrapper" [class.is-open]="isExpanded()">
          <div class="sidenav-submenu-inner">
            @for (child of $any(item()).children; track child.label) {
              <div class="pl-6">
                <app-sidenav-item [item]="child" [expanded]="expanded()" />
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
